/** Default display name for a cloned entity: "{name} Copy". */
export function defaultCloneName(name: string): string {
  const trimmed = name.trim()
  return trimmed ? `${trimmed} Copy` : 'Copy'
}

/** Default template code for clone: append CP if it fits within 8 alphanumeric chars. */
export function defaultCloneCode(code: string): string {
  const base = code.toUpperCase().replace(/[^A-Z0-9]/g, '')
  const suffix = 'CP'
  if (base.length + suffix.length <= 8) {
    return base + suffix
  }
  return (base.slice(0, 8 - suffix.length) + suffix).slice(0, 8)
}

/** Default data source key: "{key} Copy" normalized to lowercase with underscores. */
export function defaultCloneKey(key: string): string {
  return `${key.trim()} Copy`.toLowerCase().replace(/\s+/g, '_')
}
